var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "new-version-modal-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "new-version-modal-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.handleClose.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "new-version-modal-container",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "new-version-modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "new-version-modal-close-button",
                      on: { click: _vm.handleClose },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("close"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "new-version-modal-content" }, [
                  _c("div", { staticClass: "new-version-modal-icon-wrapper" }, [
                    _c(
                      "i",
                      {
                        staticClass:
                          "material-icons new-version-modal-update-icon",
                      },
                      [_vm._v("system_update")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "new-version-modal-title" }, [
                    _vm._v("Yeni Sürüm Mevcut"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "new-version-modal-description" }, [
                    _vm._v(
                      "Yeni bir sürüm mevcut. Lütfen yeni sürüme geçmek için aşağıdaki butona tıklayın."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "new-version-modal-version-info" }, [
                    _c(
                      "div",
                      { staticClass: "new-version-modal-version-badge" },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("info_outline"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Mevcut Sürüm: "),
                          _c("strong", [_vm._v(_vm._s(_vm.versionStr))]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "new-version-modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "new-version-modal-cancel-button",
                      on: { click: _vm.handleClose },
                    },
                    [
                      _vm._v(
                        "\n                    Daha Sonra\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "new-version-modal-update-button",
                      on: { click: _vm.handleUpdate },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("download"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Yeni Sürümü Yükle")]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }